var _rect, _rect2, _rect3, _rect4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeekCornerChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112 96",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 58,
    width: 16,
    height: 26,
    rx: 2,
    fill: "#c4c4c4",
    opacity: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 16,
    height: 42,
    rx: 2,
    fill: "#b8b8b8",
    opacity: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 28,
    width: 16,
    height: 56,
    rx: 2,
    fill: "#adadad",
    opacity: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 14,
    width: 16,
    height: 70,
    rx: 2,
    fill: "#a0a0a0",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 50 L52 24 L70 36 L96 10",
    stroke: "#8f8f8f",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 10 H96 V22",
    stroke: "#8f8f8f",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekCornerChart);
export default __webpack_public_path__ + "static/media/week-corner-chart.511b4ea83c6066e75181466571e6041b.svg";
export { ForwardRef as ReactComponent };